import classNames from 'classnames';
import * as Ribbons from '@/assets/graphics/ribbons/ribbons';
import { capitalizeFirstLetter } from '@/libraries/formatters/capitalize-first-letter';
import styles from './ribbon.module.scss';

export interface RibbonProps {
  /** The class name to apply */
  className?: string;
  /** The variant to show */
  variant?: 'bottom' | 'top';
}

const Ribbon = ({ className, variant = 'top' }: RibbonProps) => {
  const name = `${capitalizeFirstLetter('default')}${capitalizeFirstLetter(`${variant}`)}`;

  const RibbonComponent = Ribbons[name];

  if (!RibbonComponent) return null;

  return (
    <div className={classNames(styles.component, className)}>
      <RibbonComponent className={styles.ribbon} />
    </div>
  );
};

Ribbon.displayName = 'Ribbon';

export default Ribbon;
